import { render, staticRenderFns } from "./PatientCreate.vue?vue&type=template&id=b64b4572&scoped=true"
import script from "./PatientCreate.vue?vue&type=script&lang=js"
export * from "./PatientCreate.vue?vue&type=script&lang=js"
import style0 from "./PatientCreate.vue?vue&type=style&index=0&id=b64b4572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b4572",
  null
  
)

export default component.exports